import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';

interface Payload {
  layoutType: LayoutType;
  sectionName: string;
  targetTab: string | null;
  targetIndex: number;
}

export const moveSectionToTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, sectionName, targetTab, targetIndex } = payload;
  const sections = state[layoutType].sections;
  const tabs = state[layoutType].tabs;

  if (targetTab !== null && !tabs.some((t) => t.id === targetTab)) return;

  const sourceIndex = sections.findIndex((s) => s.name === sectionName);
  if (sourceIndex === -1) return;

  const [moved] = sections.splice(sourceIndex, 1);
  moved.tabId = targetTab;

  // Adjust targetIndex: after splicing the source, indices after sourceIndex shift down by 1.
  const adjustedTargetIndex = sourceIndex < targetIndex ? targetIndex - 1 : targetIndex;
  const insertIndex = Math.max(0, Math.min(adjustedTargetIndex, sections.length));
  sections.splice(insertIndex, 0, moved);
};
